import { takeLatest, call, put, select } from 'redux-saga/effects'
import * as actions from './actions'
import { startLoading, stopLoading, enqueueSnackbar } from '../root/actions'
import axios from 'axios'
import moment from 'moment'
import { getSagasMsgs } from '../root/selectors'
import { DEFAULT_TAKE } from '../reports/reducers'
import qs from 'qs'
import { prepareReportsFiltersAsParams } from 'web/src/utils'
import { DEFAUL_DEVICES_TAKE } from '../devices/constants'

export const watchLocationsSaga = [
    takeLatest(actions.LOCATIONS_REQUEST, requestLocations),
    takeLatest(actions.LOCATION_REQUEST, requestLocation),
    takeLatest(actions.LOCATION_UPDATE_REQUEST, updateLocation),
    takeLatest(actions.LOCATION_CREATE_REQUEST, createLocation),
    takeLatest(actions.LOCATIONS_DELETE_REQUEST, deleteLocations),
    takeLatest(actions.SHARED_USERS_REQUEST, requestSharedUsers),
    takeLatest(actions.SHARE_LOCATIONS_REQUEST, shareLocations),
    takeLatest(actions.LOCATION_DEVICES_REQUEST, getLocationDevices),
    takeLatest(actions.FETCH_MORE_LOCATION_DEVICES, getMoreLocationDevices),
    takeLatest(
        actions.LOCATION_NETWORK_DEVICES_REQUEST,
        getLocationNetworkDevices
    ),
    takeLatest(actions.LOCATION_REPORTS_REQUEST, getLocationReports),
    takeLatest(actions.LOCATION_MORE_REPORTS_REQUEST, getMoreLocationReports),
    takeLatest(
        actions.LOCATION_STATISTICS_REPORTS_REQUEST,
        getLocationStatisticsReports
    ),
    takeLatest(
        actions.LOCATION_ASSIGNED_USERS_REQUEST,
        getLocationAssignedUsers
    ),
    takeLatest(actions.AVAILABLE_DEVICES_REQUEST, getAvailableDevices),
    takeLatest(
        actions.AVAILABLE_NETWORK_DEVICES_REQUEST,
        getAvailableNetworkDevices
    ),
    takeLatest(actions.MOVE_DEVICES_REQUEST, moveDevices),
    takeLatest(actions.MOVE_NETWORK_DEVICES_REQUEST, moveNetworkDevices),
    takeLatest(actions.CREATE_FLOOR_PLAN_REQUEST, createFloorPlan),
    takeLatest(actions.FLOOR_PLAN_REQUEST, getFloorPlan),
    takeLatest(actions.DELETE_FLOOR_PLAN_REQUEST, deleteFloorPlan),
    takeLatest(
        actions.AVAILABLE_DEVICES_TO_FLOOR_PLANS_REQUEST,
        getAvailableDevicesToFloorPlans
    ),
    takeLatest(
        actions.UPDATE_DEVICE_OF_FLOOR_PLAN_REQUEST,
        updateDeviceOfFloorPlan
    ),
    takeLatest(
        actions.DELETE_DEVICE_FROM_FLOOR_PLAN_REQUEST,
        deleteDeviceFromFloorPlan
    ),
    takeLatest(actions.REFRESH_FLOOR_PLAN_DEVICES, refreshFloorPlanDevices),
    takeLatest(actions.GET_ESCALATION_LEVELS, getEscalationLevels),
    takeLatest(actions.POST_ESCALATION_LEVELS, postEscalationLevels)
]

const getDevicesSkip = state => state.locations.devicesSkip
const getReportsSkip = state => state.locations.reportsSkip

function* requestLocations(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(actions.startLocationsSidebarLoading())
        const response = yield call(fetchLocations, action.params)
        yield put(actions.locationsRequestSuccess(response))
        yield put(actions.setPickerLocationsList(response))
        yield put(actions.stopLocationsSidebarLoading())
    } catch (ex) {
        yield put(actions.locationsRequestError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationsEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(actions.stopLocationsSidebarLoading())
    }
}

async function fetchLocations(params) {
    const response = await axios.get(`${process.env.API_URL}/locations`, {
        params
    })
    return response.data
}

function* requestLocation(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(fetchLocation, action.locationId)
        yield put(actions.locationRequestSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationRequestError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function fetchLocation(locationId) {
    const response = await axios.get(
        `${process.env.API_URL}/locations/${locationId}`
    )
    return response.data
}

function* updateLocation(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(updateLocationRequest, action.locationId, action.body)
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateLocationRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.locationUpdateSuccess())
        yield put(actions.locationRequest(action.locationId))
        yield put(actions.locationsRequest())
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationUpdateError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateLocationEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function updateLocationRequest(locationId, body) {
    await axios.patch(`${process.env.API_URL}/locations/${locationId}`, body)
}

function* createLocation(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(createLocationRequest, action.body)
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.createLocationRes,
                options: {
                    variant: 'success'
                }
            })
        )
        action.history.push(`/locations/${response}/overview`)
        yield put(actions.locationsRequest())
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationCreateError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.createLocationEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function createLocationRequest(body) {
    const response = await axios.post(`${process.env.API_URL}/locations/`, body)
    return response.data
}

function* deleteLocations(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(deleteLocationsRequest, action.body)
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deleteLocationRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.locationsDeleteSuccess())
        yield put(actions.locationsRequest())
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationsDeleteError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deleteLocationEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function deleteLocationsRequest(body) {
    await axios.delete(`${process.env.API_URL}/locations/`, {
        data: body
    })
}

function* requestSharedUsers() {
    try {
        const response = yield call(fetchSharedUsers)
        yield put(actions.sharedUsersRequestSuccess(response))
    } catch (ex) {
        yield put(actions.sharedUsersRequestError())
    }
}

async function fetchSharedUsers() {
    const response = await axios.get(`${process.env.API_URL}/users/shared`)
    return response.data
}

function* shareLocations(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        /* const response =  */ yield call(
            shareLocationsRequest,
            action.locations
        )
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.shareLocationRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.shareLocationsSuccess())
        yield put(actions.locationsRequest())
    } catch (ex) {
        yield put(actions.shareLocationsError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.shareLocationEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function shareLocationsRequest(locations) {
    const response = await axios.post(
        `${process.env.API_URL}/locations/share`,
        locations
    )
    return response.data
}

function* getLocationDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(
            getLocationDevicesRequest,
            action.locationId,
            action.isDevicesToMoveMode,
            {
                ...action.filters,
                skip: 0,
                take: DEFAUL_DEVICES_TAKE
            }
        )
        yield put(actions.locationDevicesSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationDevicesError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

function* getMoreLocationDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    const devicesSkip = yield select(getDevicesSkip)
    try {
        const response = yield call(
            getLocationDevicesRequest,
            action.locationId,
            action.isDevicesToMoveMode,
            {
                ...action.filters,
                skip: devicesSkip || DEFAUL_DEVICES_TAKE,
                take: DEFAUL_DEVICES_TAKE
            }
        )
        yield put(actions.fetchMoreLocationDevicesSuccess(response))
    } catch (ex) {
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function getLocationDevicesRequest(
    locationId,
    isDevicesToMoveMode,
    filters
) {
    const response = await axios.get(`${process.env.API_URL}/devices`, {
        params: {
            locationId: Number(locationId),
            with_children: isDevicesToMoveMode ? 0 : 1,
            ...filters
        },
        paramsSerializer: params => {
            return qs.stringify({ ...params })
        }
    })
    return response.data
}

function* getLocationNetworkDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(
            getLocationNetworkDevicesRequest,
            action.locationId,
            action.isDevicesToMoveMode,
            action.filters
        )
        yield put(actions.locationNetworkDevicesSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationNetworkDevicesError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getLocationNetworkDevicesRequest(
    locationId,
    isDevicesToMoveMode,
    filters
) {
    const response = await axios.get(`${process.env.API_URL}/routers`, {
        params: {
            locationId: Number(locationId),
            with_children: isDevicesToMoveMode ? 0 : 1,
            ...filters
        },
        paramsSerializer: params => {
            return qs.stringify({ ...params })
        }
    })
    return response.data
}

function* getLocationReports(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(
            getLocationReportsRequest,
            action.locationId,
            { ...action.filters, skip: 0, take: DEFAULT_TAKE }
        )
        yield put(actions.locationReportsSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationReportsError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationReportsEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

function* getMoreLocationReports(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    const skip = yield select(getReportsSkip)
    try {
        const response = yield call(
            getLocationReportsRequest,
            action.locationId,
            { ...action.filters, skip: skip, take: DEFAULT_TAKE }
        )
        yield put(actions.locationMoreReportsSuccess(response))
    } catch (ex) {
        yield put(actions.locationReportsError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationReportsEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function getLocationReportsRequest(locationId, filters) {
    const filtersToParams = prepareReportsFiltersAsParams(filters)
    const response = await axios.get(`${process.env.API_URL}/reports`, {
        params: {
            ...filtersToParams,
            locationId: Number(locationId),
            with_children: 1
        }
    })
    return response.data
}

function* getLocationStatisticsReports(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(
            getLocationStatisticsRequest,
            action.locationId
        )
        yield put(actions.locationStatisticsReportsSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationStatisticsReportsError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationReportsEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getLocationStatisticsRequest(locationId) {
    const now = moment()
    const fromTimestamp = Number(
        now
            .subtract(25, 'days')
            .utc()
            .format('X')
    )
    const from = moment.unix(fromTimestamp).format('YYYY-MM-DD')
    const response = await axios.get(`${process.env.API_URL}/reports`, {
        params: {
            locationId: Number(locationId),
            from,
            with_children: 1
        }
    })
    return response.data
}

function* getLocationAssignedUsers(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const response = yield call(
            getLocationAssignedUsersRequest,
            action.locationId,
            action.params
        )
        yield put(actions.locationAssignedUsersSuccess(response))
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.locationAssignedUsersError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getLocationSharedUsersEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getLocationAssignedUsersRequest(locationId, params) {
    const response = await axios.get(
        `${process.env.API_URL}/locations/${locationId}/users`,
        {
            params
        }
    )
    return response.data
}

function* getAvailableDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(actions.startLocationsSidebarLoading())
        const response = yield call(
            getAvailableDevicesRequest,
            action.locationId,
            action.customerId,
            action.params
        )
        yield put(actions.availableDevicesSuccess(response))
        yield put(actions.stopLocationsSidebarLoading())
    } catch (ex) {
        yield put(actions.availableDevicesError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getAvailableDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(actions.stopLocationsSidebarLoading())
    }
}

async function getAvailableDevicesRequest(locationId, customerId, params) {
    const response = await axios.get(`${process.env.API_URL}/devices`, {
        params: {
            customer_id: customerId,
            ...params
        }
    })
    const availableDevices = response.data.filter(
        d =>
            d.location_id !== Number(locationId) &&
            d.customer_id === Number(customerId)
    )
    return availableDevices
}

function* getAvailableNetworkDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(actions.startLocationsSidebarLoading())
        const response = yield call(
            getAvailableNetworkDevicesRequest,
            action.locationId,
            action.customerId,
            action.params
        )
        yield put(actions.availableNetworkDevicesSuccess(response))
        yield put(actions.stopLocationsSidebarLoading())
    } catch (ex) {
        yield put(actions.availableNetworkDevicesError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getAvailableDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(actions.stopLocationsSidebarLoading())
    }
}

async function getAvailableNetworkDevicesRequest(
    locationId,
    customerId,
    params
) {
    const response = await axios.get(`${process.env.API_URL}/routers`, {
        params: {
            customer_id: customerId,
            ...params
        }
    })
    const availableDevices = response.data.filter(
        d =>
            d.location_id !== Number(locationId) &&
            d.customer_id === Number(customerId)
    )
    return availableDevices
}

function* moveDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        // yield put(startLoading())
        yield call(moveDevicesRequest, action.devicesToMove)
        yield put(actions.moveDevicesSuccess())
        /* yield put(
            enqueueSnackbar({
                message: sagasMsgs.moveDevicesRes,
                options: {
                    variant: 'success'
                }
            })
        ) */
        const customerId = action.devicesToMove[0].customer_id
        const locationId = action.devicesToMove[0].location_id

        const locations = yield call(fetchLocations)
        yield put(actions.locationsRequestSuccess(locations))

        const devicesWithChildren = yield call(
            getLocationDevicesRequest,
            locationId,
            false
        )

        yield put(actions.locationDevicesSuccess(devicesWithChildren))
        const devicesWithoutChildren = devicesWithChildren.filter(
            d => d.location_id === locationId
        )
        const networkDevicesRes = yield call(
            getLocationNetworkDevicesRequest,
            locationId,
            true
        )
        yield put(
            actions.floorPlanDevicesSuccess(
                devicesWithoutChildren,
                networkDevicesRes
            )
        )
        const availableDevices = yield call(
            getAvailableDevicesRequest,
            locationId,
            customerId
        )
        yield put(actions.availableDevicesSuccess(availableDevices))

        // yield put(stopLoading())
    } catch (ex) {
        yield put(actions.moveDevicesError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.moveDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        // yield put(stopLoading())
    }
}

async function moveDevicesRequest(devicesToMove) {
    await axios.patch(`${process.env.API_URL}/devices/move`, devicesToMove)
}

function* moveNetworkDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        // yield put(startLoading())
        yield call(moveNetworkDevicesRequest, action.devicesToMove)
        yield put(actions.moveNetworkDevicesSuccess())
        const customerId = action.devicesToMove[0].customer_id
        const locationId = action.devicesToMove[0].location_id
        const devicesRes = yield call(
            getLocationDevicesRequest,
            locationId,
            true
        )
        const networkDevicesWithChildren = yield call(
            getLocationNetworkDevicesRequest,
            locationId,
            false
        )
        yield put(
            actions.locationNetworkDevicesSuccess(networkDevicesWithChildren)
        )
        const networkDevicesWithoutChildren = networkDevicesWithChildren.filter(
            d => d.location_id === locationId
        )
        yield put(
            actions.floorPlanDevicesSuccess(
                devicesRes,
                networkDevicesWithoutChildren
            )
        )
        /* yield put(
            enqueueSnackbar({
                message: sagasMsgs.moveDevicesRes,
                options: {
                    variant: 'success'
                }
            })
        ) */
        const locations = yield call(fetchLocations)
        yield put(actions.locationsRequestSuccess(locations))
        const availableNetworkDevices = yield call(
            getAvailableNetworkDevicesRequest,
            locationId,
            customerId,
            action.params
        )
        yield put(
            actions.availableNetworkDevicesSuccess(availableNetworkDevices)
        )
        // yield put(stopLoading())
    } catch (ex) {
        yield put(actions.moveNetworkDevicesError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.moveDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        // yield put(stopLoading())
    }
}

async function moveNetworkDevicesRequest(devicesToMove) {
    await axios.patch(`${process.env.API_URL}/routers/move`, devicesToMove)
}

function* createFloorPlan(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(createFloorPlanRequest, action.body)
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.createFloorPlanRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.createFloorPlanSuccess())
        yield put(actions.floorPlanRequest(action.body.location_id))
        // yield put(actions.locationsRequest())
    } catch (ex) {
        yield put(actions.createFloorPlanError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.createFloorPlanEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function createFloorPlanRequest(body) {
    const formData = new FormData()
    formData.append('file', body.file, body.file.name)
    formData.append('location_id', body.location_id)
    formData.append('customer_id', body.customer_id)
    formData.append('is_floorplan_replacement', body.isFileReplacement)
    await axios.post(`${process.env.API_URL}/floor-plans/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

function* getFloorPlan(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        const floorplanRes = yield call(getFloorPlanRequest, action.locationId)
        yield put(actions.floorPlanSuccess(floorplanRes))
        const devicesRes = yield call(
            getLocationDevicesRequest,
            action.locationId,
            true
        )
        const networkDevicesRes = yield call(
            getLocationNetworkDevicesRequest,
            action.locationId,
            true
        )
        yield put(
            actions.floorPlanDevicesSuccess(devicesRes, networkDevicesRes)
        )
        yield put(actions.locationRequest(action.locationId))
        // don't stop loading - location request will do
    } catch (ex) {
        yield put(actions.floorPlanError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getFloorPlanEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function getFloorPlanRequest(locationId) {
    const response = await axios.get(
        `${process.env.API_URL}/floor-plans/${locationId}`
    )
    return response.data
}

function* deleteFloorPlan(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(startLoading())
        yield call(deleteFloorPlanRequest, action.id)
        yield put(actions.deleteFloorPlanSuccess())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deleteFloorPlanRes,
                options: {
                    variant: 'success'
                }
            })
        )
        yield put(actions.floorPlanSuccess(null))
        const devicesRes = yield call(
            getLocationDevicesRequest,
            action.locationId,
            true
        )
        const networkDevicesRes = yield call(
            getLocationNetworkDevicesRequest,
            action.locationId,
            true
        )
        yield put(
            actions.floorPlanDevicesSuccess(devicesRes, networkDevicesRes)
        )
        yield put(stopLoading())
    } catch (ex) {
        yield put(actions.deleteFloorPlanError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deleteFloorPlanEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(stopLoading())
    }
}

async function deleteFloorPlanRequest(id) {
    await axios.delete(`${process.env.API_URL}/floor-plans/${id}`)
}

function* getAvailableDevicesToFloorPlans(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(actions.startLocationsSidebarLoading())
        const response = yield call(
            getAvailableDevicesToFloorPlansRequest,
            action.locationId,
            action.customerId,
            action.params
        )
        yield put(actions.availableDevicesToFloorPlansSuccess(response))
        yield put(actions.stopLocationsSidebarLoading())
    } catch (ex) {
        yield put(actions.availableDevicesToFloorPlansError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getFPAvailableDevicesEx,
                options: {
                    variant: 'error'
                }
            })
        )
        yield put(actions.stopLocationsSidebarLoading())
    }
}

async function getAvailableDevicesToFloorPlansRequest(
    locationId,
    customerId,
    params
) {
    const devices = await axios.get(`${process.env.API_URL}/devices`, {
        params
    })
    const networkDevices = await axios.get(`${process.env.API_URL}/routers`, {
        params
    })
    const availableDevices = devices.data.filter(
        d => d.customer_id === Number(customerId)
    )
    const availableNetworkDevices = networkDevices.data.filter(
        d => d.customer_id === Number(customerId)
    )
    return [...availableNetworkDevices, ...availableDevices]
}

function* updateDeviceOfFloorPlan(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        if (action.floorPlanId) {
            if (action.isNetworkDevice) {
                yield call(
                    updateNetworkDeviceOfFloorPlanRequest,
                    action.floorPlanId,
                    action.deviceId,
                    action.body
                )
            } else {
                yield call(
                    updateDeviceOfFloorPlanRequest,
                    action.floorPlanId,
                    action.deviceId,
                    action.body
                )
            }
        }
        const devicesRes = yield call(
            getLocationDevicesRequest,
            action.locationId,
            true
        )
        const networkDevicesRes = yield call(
            getLocationNetworkDevicesRequest,
            action.locationId,
            true
        )
        yield put(
            actions.floorPlanDevicesSuccess(devicesRes, networkDevicesRes)
        )
        yield put(actions.updateDeviceOfFloorPlanSuccess())
    } catch (ex) {
        yield put(actions.updateDeviceOfFloorPlanError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.updateFPDeviceEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function updateDeviceOfFloorPlanRequest(floorPlanId, deviceId, body) {
    await axios.patch(
        `${process.env.API_URL}/floor-plans/${floorPlanId}/devices/${deviceId}`,
        body
    )
}

async function updateNetworkDeviceOfFloorPlanRequest(
    floorPlanId,
    deviceId,
    body
) {
    await axios.patch(
        `${process.env.API_URL}/floor-plans/${floorPlanId}/routers/${deviceId}`,
        body
    )
}

function* deleteDeviceFromFloorPlan(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        if (action.isNetworkDevice) {
            yield call(
                deleteNetworkDeviceFromFloorPlanRequest,
                action.floorPlanId,
                action.deviceId
            )
        } else {
            yield call(
                deleteDeviceFromFloorPlanRequest,
                action.floorPlanId,
                action.deviceId
            )
        }
        const devicesRes = yield call(
            getLocationDevicesRequest,
            action.locationId,
            true
        )
        const networkDevicesRes = yield call(
            getLocationNetworkDevicesRequest,
            action.locationId,
            true
        )
        yield put(
            actions.floorPlanDevicesSuccess(devicesRes, networkDevicesRes)
        )
        yield put(actions.deleteDeviceFromFloorPlanSuccess())
    } catch (ex) {
        yield put(actions.deleteDeviceFromFloorPlanError())
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.deleteFPDeviceEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function deleteDeviceFromFloorPlanRequest(floorPlanId, deviceId) {
    await axios.delete(
        `${process.env.API_URL}/floor-plans/${floorPlanId}/devices/${deviceId}`
    )
}

async function deleteNetworkDeviceFromFloorPlanRequest(floorPlanId, deviceId) {
    await axios.delete(
        `${process.env.API_URL}/floor-plans/${floorPlanId}/routers/${deviceId}`
    )
}

function* refreshFloorPlanDevices(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        const devicesRes = yield call(
            getLocationDevicesRequest,
            action.locationId,
            true
        )
        const networkDevicesRes = yield call(
            getLocationNetworkDevicesRequest,
            action.locationId,
            true
        )
        yield put(
            actions.floorPlanDevicesSuccess(devicesRes, networkDevicesRes)
        )
    } catch (ex) {
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getFloorPlanEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

function* getEscalationLevels(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        const escalationLevels = yield call(
            getEscalationLevelsRequest,
            action.locationId
        )
        yield put(actions.setEscalationLevels(escalationLevels))
    } catch (ex) {
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.getEscalationLevelEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function getEscalationLevelsRequest(locationId) {
    const { data } = await axios.get(
        `${process.env.API_URL}/escalation-levels/${locationId}`
    )

    return data
        ? data.map(item => ({
              email: item.email,
              message: item.message,
              level: item.level,
              locale: item.locale,
              daysUntilAlert: item.days_until_alert,
              hoursUntilAlert: item.hours_until_alert,
              reportTypes: item.report_types.split(',')
          }))
        : []
}

function* postEscalationLevels(action) {
    const sagasMsgs = yield select(getSagasMsgs)

    try {
        yield call(
            postEscalationLevelsRequest,
            action.escalationLevels,
            action.locationId
        )
        yield put(actions.getEscalationLevels(action.locationId))
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.postEscalationLevelRes,
                options: {
                    variant: 'success'
                }
            })
        )
    } catch (ex) {
        yield put(
            enqueueSnackbar({
                message: sagasMsgs.postEscalationLevelEx,
                options: {
                    variant: 'error'
                }
            })
        )
    }
}

async function postEscalationLevelsRequest(escalationLevels, locationId) {
    await axios.post(
        `${process.env.API_URL}/escalation-levels/${locationId}`,
        escalationLevels
    )
}
